module.exports = __webpack_public_path__ + "static/media/n-particip-active.50179032.svg";